var _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketlaunchRafiki(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-132"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.95,
    y: 395.11,
    width: 57.98,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.67,
    y: 389.21,
    width: 54.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 14.91,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.27,
    y: 390.89,
    width: 64.4,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 395.11,
    width: 43.15,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.66,
    y: 72.84,
    width: 158.39,
    height: 90.45,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.03 163.29 173.75 72.84 143.51 72.84 183.8 163.29 214.03 163.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.74 163.29 92.45 72.84 81.42 72.84 121.71 163.29 132.74 163.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1,68.93H230.6a.71.71,0,0,1,.7.71h0a.71.71,0,0,1-.7.7H57.1a.71.71,0,0,1-.7-.7h0A.71.71,0,0,1,57.1,68.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.91,
    y: 72.6,
    width: 1.88,
    height: 90.94,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.97,
    y: 72.6,
    width: 0.94,
    height: 90.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.91,
    y: 37.78,
    width: 1.88,
    height: 160.58,
    transform: "translate(25.78 261.92) rotate(-90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.56,162.51h0V71.75H224.14v90.76h0v1.87H63.56Zm158.7,0V73.62H65.44v88.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.62,
    y: 71.75,
    width: 0.94,
    height: 92.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.42 65.75 88.42 190.81 55.46 190.81 61.51 65.75 88.42 65.75",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.34 65.75 198.34 190.81 231.3 190.81 225.26 65.75 198.34 65.75",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.89,
    y: 72.84,
    width: 158.39,
    height: 90.45,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.27 163.29 386.98 72.84 356.75 72.84 397.04 163.29 427.27 163.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.97 163.29 305.69 72.84 294.66 72.84 334.94 163.29 345.97 163.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.34,68.93H443.83a.71.71,0,0,1,.71.71h0a.71.71,0,0,1-.71.7H270.34a.7.7,0,0,1-.7-.7h0A.7.7,0,0,1,270.34,68.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.15,
    y: 72.6,
    width: 1.88,
    height: 90.94,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.21,
    y: 72.6,
    width: 0.94,
    height: 90.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.15,
    y: 37.78,
    width: 1.88,
    height: 160.58,
    transform: "translate(239.02 475.15) rotate(-90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.8,162.51h0V71.75H437.38v90.76h0v1.87H276.8Zm158.7,0V73.62H278.67v88.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.86,
    y: 71.75,
    width: 0.94,
    height: 92.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.66 65.75 301.66 190.81 268.7 190.81 274.74 65.75 301.66 65.75",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.58 65.75 411.58 190.81 444.54 190.81 438.49 65.75 411.58 65.75",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 237.74,
    width: 213.08,
    height: 12.6,
    transform: "translate(682.97 488.09) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 237.74,
    width: 54.97,
    height: 12.6,
    transform: "translate(524.86 488.09) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.34,
    y: 250.35,
    width: 18.68,
    height: 132.05,
    transform: "translate(877.36 632.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 250.35,
    width: 18.68,
    height: 132.05,
    transform: "translate(488.57 632.74) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.05,
    y: 250.35,
    width: 18.68,
    height: 132.05,
    transform: "translate(804.78 632.74) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 287.21,
    width: 213.08,
    height: 12.6,
    transform: "translate(682.97 587.03) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 287.21,
    width: 54.97,
    height: 12.6,
    transform: "translate(524.86 587.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 336.69,
    width: 213.08,
    height: 12.6,
    transform: "translate(682.97 685.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 336.69,
    width: 54.97,
    height: 12.6,
    transform: "translate(524.86 685.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.24,
    y: 250.35,
    width: 18.68,
    height: 132.05,
    transform: "translate(561.15 632.74) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.78,
    y: 247.48,
    width: 16.85,
    height: 130.38,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.12,
    y: 377.86,
    width: 130.97,
    height: 4.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.63,
    y: 247.48,
    width: 118.78,
    height: 130.38,
    transform: "translate(266.05 625.34) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.27,
    y: 296.49,
    width: 91.52,
    height: 31.33,
    rx: 4.37,
    transform: "translate(266.05 624.31) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.27,
    y: 336.81,
    width: 91.52,
    height: 31.33,
    rx: 4.37,
    transform: "translate(266.05 704.96) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.92,
    y: 295.14,
    width: 18.22,
    height: 6.76,
    rx: 2.47,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.27,
    y: 256.16,
    width: 91.52,
    height: 31.33,
    rx: 4.37,
    transform: "translate(266.05 543.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.92,
    y: 254.81,
    width: 18.22,
    height: 6.76,
    rx: 2.47,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.92,
    y: 335.46,
    width: 18.22,
    height: 6.76,
    rx: 2.47,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.63,
    y: 243.26,
    width: 121.86,
    height: 4.22,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.48,
    y: 243.26,
    width: 20.16,
    height: 4.22,
    transform: "translate(127.11 490.74) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.9 201.45 146.49 201.45 152.34 241.07 79.75 241.07 73.9 201.45",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.75 241.07 79.78 243.26 152.37 243.26 152.34 241.07 79.75 241.07",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.14 201.45 148.73 201.45 154.57 241.07 81.98 241.07 76.14 201.45",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.73 239.26 78.42 203.26 146.98 203.26 152.29 239.26 83.73 239.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.89 241.07 100.93 243.26 180.87 243.26 180.83 241.07 100.89 241.07",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-132"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-132",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,99.37c.78-6.5,11-11.61,19.87-8.54,10.18,3.53,8.57,12.86,15.3,13.23s10.1,12.29,4.21,17.81,4.93,8,5.29,15.74.39,13.75,6.73,19.48c8,7.21-4.33,30.47-24.58,19.84-18.15-9.53-40.87,4.18-44.93-9.05-3.51-11.42,13.71-23.81,10.11-29.34s-1.21-10.73,2.88-17.42C114.91,112.92,102.56,100.69,115,99.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,153.26c2.47,5,5,10.13,7.65,15.08,1.34,2.46,2.7,4.91,4.09,7.28a55.89,55.89,0,0,0,4.37,6.49l.33.39a.8.8,0,0,0,.21.19,2.94,2.94,0,0,0,.85.4,9.61,9.61,0,0,0,3,.35,35,35,0,0,0,7.59-1.16c2.63-.64,5.27-1.48,7.91-2.4s5.29-1.94,7.83-3l2.32,4.21a81,81,0,0,1-15.88,8.17,38.68,38.68,0,0,1-9.25,2.3,18,18,0,0,1-5.56-.22,11.8,11.8,0,0,1-3.15-1.17,10.23,10.23,0,0,1-1.54-1,8.54,8.54,0,0,1-.71-.64L165,188a54.8,54.8,0,0,1-5.7-7.46c-1.67-2.49-3.18-5-4.63-7.57-2.92-5.11-5.58-10.24-8-15.59Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,144c4-.14,11.19,14.56,11.19,14.56l-10.52,12.77S137.9,155.94,139.59,151C141.34,145.77,143.62,144.21,149.51,144Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.18 147.56 155.65 164.71 150.72 170.68 150.18 147.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,173.56l-9.67,4.63-.18,3.41c2.79,2.79,8.64,1,8.64,1l7.16-.93.92-4a3.51,3.51,0,0,0-3.22-4.33l-2-.1A3.55,3.55,0,0,0,206.12,173.56Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.97 408.17 139.47 408.17 140.34 386.16 130.83 386.16 129.97 408.17",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.36,407.07H129.68a.67.67,0,0,0-.7.65l-.36,8.45a1.72,1.72,0,0,0,1.7,1.69c3.71-.06,5.48-.28,10.18-.28,2.89,0,9.54.3,13.53.3s3.8-3.95,2.11-4.3c-7.61-1.61-11.41-3.82-14.14-5.92A2.7,2.7,0,0,0,140.36,407.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "140.34 386.17 139.89 397.51 130.38 397.51 130.83 386.17 140.34 386.17"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M153.32,148.72c.21,6-.83,20.05-7.15,52.73l-38.59-1.15c1.12-15.69,1.42-25.37-5.12-57.83a113.38,113.38,0,0,1,16.45-1.67,122.86,122.86,0,0,1,17.52.52c4.47.54,9.28,1.47,12.44,2.13A5.59,5.59,0,0,1,153.32,148.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,121.12c.94,5.67,1.73,16-2.32,19.68,0,0,3.75,7,13.38,9.55,8.89-4.51,4.14-9,4.14-9-6.24-1.69-5.94-6.35-4.72-10.69Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.29 150.35 131.14 148.1 124.96 149.5 132.29 150.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.14,148.1c-2-.9-11.17-6.89-11.53-8.75a20,20,0,0,0-4.6,1s1.17,6.76,8.38,14.54C125.25,150.67,127.72,148.82,131.14,148.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.29 150.35 132.81 148.1 136.6 148.37 132.29 150.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.81,148.1c3.06-2,2.31-6.29,2-8.15a31.35,31.35,0,0,1,4.61,1,12.51,12.51,0,0,1,.47,13.94C138.41,150.89,135.88,149.45,132.81,148.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5,125l6.21,5.62a18.14,18.14,0,0,0-.63,3.1c-2.4-.42-5.62-3.16-5.8-5.68A8.49,8.49,0,0,1,125.5,125Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,109.08c.41,9.42.39,13.42,5.06,18.34,7,7.39,18.51,4.81,20.92-4.54,2.17-8.43,1.12-22.43-8-26.33A12.86,12.86,0,0,0,118.24,109.08Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.93,98.82c3.49,1.75,8.3,1.45,9.2,3.55S124.5,117,119.27,117.1C114.46,110.61,113.74,101.83,116.93,98.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41,100.39c7.7,4.87,33.08,9.42,24.79-1.57C135.9,90.48,119.33,94.68,117.41,100.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26,201.45s3.73,70.23,3.92,99.09c.2,30-8.25,94.77-8.25,94.77H129.07s2.45-65.45.47-95.07c-2.16-32.29-9.67-99.63-9.67-99.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128 395.78 143.09 395.78 143.71 390.96 126.76 390.38 128 395.78",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59,225.83c1.39-1.73,3.21-.84,5.59,4.1,8.12,16.84,4,43.71.52,59.19C127.14,269.85,124.56,244.46,122.59,225.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85,112.65c0,.77.38,1.4.88,1.41s.92-.61.93-1.37-.38-1.4-.88-1.41S133.86,111.89,133.85,112.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,112.58c0,.77.38,1.4.88,1.41s.92-.61.93-1.37-.38-1.4-.88-1.41S142.52,111.82,142.51,112.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.21,111.25l1.85-.5S144.1,112.17,143.21,111.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.18,113.32a20.35,20.35,0,0,0,2.65,4.94,3.31,3.31,0,0,1-2.75.47Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,121.66a7.92,7.92,0,0,0,1.13.1.23.23,0,1,0,0-.45,6,6,0,0,1-4.91-2.46.23.23,0,0,0-.31-.07.22.22,0,0,0-.07.31A6.32,6.32,0,0,0,134.85,121.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,117.67a6.88,6.88,0,0,0,3.52,3.91c2.19,1,3.68-.84,3.4-3.12-.25-2-1.69-5-4-5.11A3.09,3.09,0,0,0,115.54,117.67Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.36,110.12a.42.42,0,0,0,.47-.23c1-1.84,3.63-2.21,3.66-2.21a.45.45,0,0,0,.39-.51.45.45,0,0,0-.51-.38c-.13,0-3.15.43-4.33,2.68a.45.45,0,0,0,.19.61A.28.28,0,0,0,130.36,110.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.14,108.14a.44.44,0,0,0,.42-.15.45.45,0,0,0-.05-.64,4.46,4.46,0,0,0-4-1,.45.45,0,0,0,.26.86h0a3.57,3.57,0,0,1,3.14.85A.45.45,0,0,0,145.14,108.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.34,157.36c-2.74,3.92-5.5,8.11-8.07,12.26a137.46,137.46,0,0,0-7,12.74l-.38.8-.19.41c0,.1,0,0,0,0a0,0,0,0,0,0,0s-.09.14-.09.45a9.38,9.38,0,0,0,.39,2.59A41.43,41.43,0,0,0,93.42,193c2.06,4.32,4.55,8.7,7.07,12.92l-3.8,3A83.93,83.93,0,0,1,87,196.61a40.68,40.68,0,0,1-3.84-7.38,17,17,0,0,1-1.16-4.8,9.84,9.84,0,0,1,.29-3.3c0-.15.09-.31.14-.47l.15-.4.18-.47.36-.93c1-2.5,2.06-4.9,3.22-7.25S88.7,167,90,164.69a135.11,135.11,0,0,1,8.53-13.09Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,142.47c-3.91,1.06-8.95,14.24-8.95,14.24l14.69,11.17s5.8-10.95,4.32-16C111,146.63,106.91,141.26,102.46,142.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,408.73a3.31,3.31,0,0,0,2.25-.58,1.18,1.18,0,0,0,.3-1.1.87.87,0,0,0-.45-.6c-1.23-.63-4.82,1.3-5.23,1.52a.22.22,0,0,0-.09.24.23.23,0,0,0,.2.18A16.76,16.76,0,0,0,144.09,408.73Zm1.5-2a.92.92,0,0,1,.43.08.29.29,0,0,1,.17.24.74.74,0,0,1-.18.72c-.53.52-2.08.61-4.23.26A11.31,11.31,0,0,1,145.59,406.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.11,408.4l.09,0c1.08-.51,3.12-2.56,2.83-3.64-.06-.26-.28-.57-.91-.64a1.53,1.53,0,0,0-1.2.39c-1.1,1-1.06,3.56-1.06,3.67a.27.27,0,0,0,.12.2A.33.33,0,0,0,141.11,408.4Zm1.88-3.86h.13c.42,0,.46.21.48.26.17.65-1.19,2.26-2.28,3,0-.74.2-2.28.92-2.93A1.07,1.07,0,0,1,143,404.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.12 408.17 99.63 408.17 102.79 386.16 93.28 386.16 90.12 408.17",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,407.07H89.3a.77.77,0,0,0-.77.65l-1.32,8.45a1.5,1.5,0,0,0,1.5,1.69c3.72-.06,5.52-.28,10.22-.28,2.89,0,5.25.3,9.24.3s4.25-3.95,2.59-4.3c-7.43-1.61-6.72-3.82-9.2-5.92A2.48,2.48,0,0,0,100,407.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,408.73a3.62,3.62,0,0,0,2.32-.58,1.29,1.29,0,0,0,.42-1.1.71.71,0,0,0-.38-.6c-1.15-.63-5,1.3-5.4,1.52a.24.24,0,0,0-.12.24.2.2,0,0,0,.18.18A16.09,16.09,0,0,0,101.5,408.73Zm1.72-2a.83.83,0,0,1,.42.08.27.27,0,0,1,.15.24.83.83,0,0,1-.27.72c-.58.52-2.15.61-4.25.26A12.46,12.46,0,0,1,103.22,406.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56,408.4l.09,0c1.14-.51,3.41-2.56,3.25-3.64,0-.26-.22-.57-.84-.64a1.69,1.69,0,0,0-1.25.39c-1.21,1-1.46,3.56-1.47,3.67a.21.21,0,0,0,.09.2A.28.28,0,0,0,98.56,408.4Zm2.31-3.86H101c.41,0,.43.21.44.26.1.65-1.44,2.26-2.61,3a5.3,5.3,0,0,1,1.25-2.93A1.19,1.19,0,0,1,100.87,404.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.79 386.17 101.16 397.51 91.65 397.51 93.28 386.17 102.79 386.17"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.58,200.3C98.32,215,100.91,269.14,99.45,298c-1.52,30-9,97.27-9,97.27h12.85s12.34-68.42,18.09-97.43c6.35-32,14.08-97.58,14.08-97.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.63 395.78 104.71 395.78 105.25 390.96 88.29 390.38 89.63 395.78",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.56,111.32l1.85-.5S135.44,112.24,134.56,111.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07,198,106,201.44c-.14.27.17.55.61.56l39.72,1.18c.35,0,.64-.15.67-.37l.45-3.44c0-.24-.26-.45-.64-.46l-39.08-1.16A.7.7,0,0,0,107.07,198Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19,202.54l-1,0c-.2,0-.36-.12-.34-.25l.62-4.47c0-.13.21-.23.41-.23l1,0c.21,0,.36.12.35.25l-.63,4.48C112.58,202.45,112.4,202.55,112.19,202.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,203.47l-1.05,0c-.21,0-.36-.12-.34-.25l.62-4.47c0-.13.21-.24.41-.23l1.05,0c.21,0,.36.12.35.25l-.63,4.47C143.75,203.37,143.57,203.48,143.36,203.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,203l-1,0c-.21,0-.37-.12-.35-.25l.63-4.48c0-.13.2-.23.41-.22l1,0c.2,0,.36.12.34.25l-.62,4.47C128.17,202.91,128,203,127.77,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.38,203.43l10.12,1.74-7.39,6.23c.1.06-5.61-2.15-6.18-6.12Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,213l-2.23,1.68a2.88,2.88,0,0,1-3.44,0l-4.56-3.31,7.39-6.23,3.25,3.57A2.9,2.9,0,0,1,110.34,213Z",
    style: {
      fill: "#ce7a63"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--maker-launch--inject-132"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.35,
    y: 181.66,
    width: 262.17,
    height: 162.8,
    rx: 8.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.62,345H156.24a9.41,9.41,0,0,1-9.4-9.4v-145a9.41,9.41,0,0,1,9.4-9.4H400.62a9.42,9.42,0,0,1,9.41,9.4v145A9.42,9.42,0,0,1,400.62,345ZM156.24,182.16a8.41,8.41,0,0,0-8.39,8.39v145a8.4,8.4,0,0,0,8.39,8.39H400.62a8.39,8.39,0,0,0,8.39-8.39v-145a8.4,8.4,0,0,0-8.39-8.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.32,344.46H150.55a7,7,0,0,0-5.3,2.42l-9.44,10.93a7,7,0,0,0,5.3,11.58H415.76a7,7,0,0,0,5.3-11.58l-9.45-10.93A7,7,0,0,0,406.32,344.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.76,369.89H141.11a7.51,7.51,0,0,1-5.68-12.42l9.44-10.92a7.52,7.52,0,0,1,5.68-2.6H406.31a7.52,7.52,0,0,1,5.69,2.6l9.44,10.92a7.51,7.51,0,0,1-5.68,12.42ZM150.55,345a6.47,6.47,0,0,0-4.91,2.25l-9.45,10.93a6.49,6.49,0,0,0,4.92,10.74H415.76a6.49,6.49,0,0,0,4.91-10.74l-9.44-10.93a6.49,6.49,0,0,0-4.92-2.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.64,362.29a3.12,3.12,0,0,0-2,5.52,6.88,6.88,0,0,0,4.44,1.58H415.75a6.93,6.93,0,0,0,4.67-1.76,3.11,3.11,0,0,0-2.18-5.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.1,
    y: 137.04,
    width: 152.66,
    height: 252.04,
    rx: 3.83,
    transform: "translate(541.49 -15.38) rotate(90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69,336.64H158.18a3,3,0,0,1-3-3V192.49a3,3,0,0,1,3-3H398.69a3,3,0,0,1,3,3V333.63A3,3,0,0,1,398.69,336.64ZM158.18,190a2.52,2.52,0,0,0-2.52,2.52V333.63a2.52,2.52,0,0,0,2.52,2.51H398.69a2.52,2.52,0,0,0,2.51-2.51V192.49a2.52,2.52,0,0,0-2.51-2.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.28,242.82c0,5,48.4,5,48.4,0C365.68,215.07,317.28,215.07,317.28,242.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,247.08a129.12,129.12,0,0,1-16.71-.94c-7.2-1-8-2.37-8-3.32,0-14.67,12.83-21.35,24.74-21.35h0c11.92,0,24.74,6.68,24.74,21.35C366.22,246.87,345.61,247.08,341.48,247.08Zm-23.66-4.26c0,1.33,8.23,3.18,23.66,3.18s23.66-1.85,23.66-3.18c0-13.93-12.26-20.27-23.66-20.27s-23.66,6.34-23.66,20.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.67,180c3.74,7.85,8.13,26,8.81,40.41a3,3,0,0,1-4.42,2.79,10.8,10.8,0,0,0-3.53-1.21c-1.45-.22-2.56-2.25-2.59-4.7l-.48-36C367.44,179.36,368.93,178.47,369.67,180Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.47,224.1a3.49,3.49,0,0,1-1.65-.42,10.5,10.5,0,0,0-3.36-1.16c-1.72-.26-3-2.44-3-5.19l-.47-36a2.45,2.45,0,0,1,1.46-2.6,1.56,1.56,0,0,1,1.71,1.05h0c3.71,7.79,8.16,26,8.86,40.6a3.55,3.55,0,0,1-3.52,3.69Zm-6.77-44.36h-.05c-.28.07-.69.62-.68,1.59l.48,36c0,2.17,1,4,2.16,4.2a11.17,11.17,0,0,1,3.69,1.27,2.5,2.5,0,0,0,3.67-2.33c-.69-14.52-5.09-32.52-8.76-40.22h0C369.15,180.12,369,179.74,368.7,179.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.37,227.46c0,7.16-57.78,7.16-57.78,0V147.82a108,108,0,0,1,11.47-49.09c4.8-9.43,10.81-17.37,17.42-17.37S354.1,89.3,358.9,98.73a108,108,0,0,1,11.47,49.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,233.34a129.24,129.24,0,0,1-20-1.35c-6.36-1.05-9.45-2.53-9.45-4.53V147.82A109,109,0,0,1,323.61,98.5c6-11.71,12-17.65,17.87-17.65s11.91,5.94,17.87,17.65a109,109,0,0,1,11.53,49.32v79.64h0C370.88,233.17,344.49,233.34,341.48,233.34Zm0-151.47c-5.48,0-11.19,5.75-17,17.09a108,108,0,0,0-11.42,48.86v79.64c0,2.73,12.47,4.86,28.39,4.86s28.39-2.13,28.39-4.86V147.82A108,108,0,0,0,358.45,99C352.67,87.62,347,81.87,341.48,81.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,119.82c-9.32,0-17.89-2.54-23.51-7l.63-.8c5.36,4.23,13.92,6.75,22.88,6.75s17.52-2.52,22.88-6.75l.63.8C359.37,117.28,350.8,119.82,341.48,119.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.49,180c-6.46,8.06-14,27-14.86,41.56a3,3,0,0,0,4.26,2.92A27.22,27.22,0,0,1,313,222a4.81,4.81,0,0,0,4.36-4.7l.79-36A2.06,2.06,0,0,0,314.49,180Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.63,225.31a3.46,3.46,0,0,1-1.94-.6,3.54,3.54,0,0,1-1.57-3.15c.84-14.69,8.56-33.85,15-41.85h0a2.58,2.58,0,0,1,4.6,1.65l-.8,36a5.32,5.32,0,0,1-4.81,5.2,26.38,26.38,0,0,0-9,2.44A3.37,3.37,0,0,1,302.63,225.31Zm12.25-45c-6.31,7.89-13.92,26.78-14.75,41.28a2.52,2.52,0,0,0,1.13,2.25,2.44,2.44,0,0,0,2.42.19,27.11,27.11,0,0,1,9.31-2.54,4.3,4.3,0,0,0,3.89-4.21l.79-36a1.52,1.52,0,0,0-1-1.5,1.54,1.54,0,0,0-1.77.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.69,
    cy: 157.97,
    rx: 16.78,
    ry: 24.02,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.28,
    cy: 157.97,
    rx: 12.93,
    ry: 20.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,339.93a.55.55,0,0,1-.55-.54c0-.52,0-1.17,0-1.9-.17-5.63-.52-17.33,6.69-24,4.39-4.09,10.93-5.73,19.44-4.87,26.73,2.71,41.62-4.7,53.1-26.41,5.1-9.64,16.16-11,25.93-12.16,7.47-.91,14.52-1.76,17.7-6.17,1.94-2.69,2.36-6.57,1.29-11.85a.54.54,0,0,1,.43-.64.53.53,0,0,1,.63.42c1.14,5.6.66,9.75-1.47,12.7-3.46,4.79-10.74,5.68-18.45,6.61-10,1.21-20.27,2.46-25.1,11.6-11.73,22.17-26.92,29.74-54.17,27-8.19-.83-14.45.71-18.6,4.58-6.84,6.38-6.5,17.75-6.34,23.22,0,.74.05,1.4.05,1.93A.54.54,0,0,1,204,339.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,339.93a.55.55,0,0,1-.54-.53v-.57c-.17-10-.4-23.61,14.75-25.56,9-1.15,14.29-3.32,16.24-6.62s.28-7.69-1.37-11.87c-1.44-3.64-2.92-7.4-2-10.59a32.35,32.35,0,0,1,7.67-13.2c4.06-4.65,6.3-7.21-1.52-18.81a.55.55,0,0,1,.15-.75.54.54,0,0,1,.75.15c8.28,12.29,5.7,15.24,1.43,20.12a31.54,31.54,0,0,0-7.44,12.8c-.84,2.83.51,6.26,1.94,9.88,1.75,4.43,3.55,9,1.3,12.82-2.13,3.61-7.71,5.95-17,7.15-14.18,1.82-14,14.91-13.8,24.46v.57a.54.54,0,0,1-.53.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,232.14h-.34a9.76,9.76,0,0,0-8.62-6.16,10,10,0,0,0-3,.3,10.05,10.05,0,0,0-19.21,2.54,7.85,7.85,0,0,0-.22,15.68L209.36,246a6.93,6.93,0,1,0,.67-13.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,200.22h0a12.06,12.06,0,0,1,10.48,18.08l-9.61-6.73-5-10.63a11.73,11.73,0,0,1,4.08-.72m0-1.08a13,13,0,0,0-5.54,1.23l5.56,11.92L265,219.83a13.15,13.15,0,0,0-10.79-20.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.27,212.29,265,219.83a13.06,13.06,0,0,1-1.47,1.76,13.16,13.16,0,1,1-14.86-21.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.93,293.79a3.27,3.27,0,0,1-3.24-2.76l-3.54-21.6a3.3,3.3,0,0,1,2.72-3.79l35.92-5.88a3.3,3.3,0,0,1,3.78,2.72l3.54,21.6a3.31,3.31,0,0,1-2.72,3.79h0l-35.92,5.88A3.27,3.27,0,0,1,218.93,293.79Zm32.39-33-.36,0L215,266.71a2.23,2.23,0,0,0-1.83,2.54l3.54,21.61a2.25,2.25,0,0,0,.9,1.44,2.19,2.19,0,0,0,1.65.38l35.92-5.88a2.21,2.21,0,0,0,1.82-2.54l-3.54-21.61a2.2,2.2,0,0,0-.89-1.44A2.22,2.22,0,0,0,251.32,260.8Zm4,26.53h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.74 275.67 229.6 271.08 231.7 283.9 241.74 275.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.5,
    y: 258.24,
    width: 7.29,
    height: 21.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.5,
    y: 281.71,
    width: 7.29,
    height: 4.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.5,
    y: 288.35,
    width: 7.29,
    height: 2.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.5,
    y: 294.18,
    width: 7.29,
    height: 1.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.87 260.26 386.14 247.67 393.41 260.26 378.87 260.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.4,
    y: 222.94,
    width: 4.6,
    height: 13.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.4,
    y: 237.76,
    width: 4.6,
    height: 2.61,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.4,
    y: 241.96,
    width: 4.6,
    height: 1.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.4,
    y: 245.64,
    width: 4.6,
    height: 0.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.11 224.22 285.7 216.26 290.3 224.22 281.11 224.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.65,
    y: 142.44,
    width: 5.85,
    height: 17.6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.65,
    y: 161.27,
    width: 5.85,
    height: 3.31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.65,
    y: 166.6,
    width: 5.85,
    height: 1.66,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.65,
    y: 171.28,
    width: 5.85,
    height: 0.83,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.74 144.06 389.57 133.96 395.4 144.06 383.74 144.06",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketlaunchRafiki);
export default __webpack_public_path__ + "static/media/Market launch-rafiki.f8524635a5356d4a897ac7b992bca63c.svg";
export { ForwardRef as ReactComponent };